<!-- 订单支付 输密码 -->

<template>
  <div class="page-bg">
    <template v-if="orderType != null && orderType != 0">
      <van-cell-group inset title="卡券抵扣">
        <van-cell :value="cardQuantity" title="次数" />
        <van-cell :value="cardMoney / 100" title="金额" />
      </van-cell-group>

      <van-cell-group inset title="第三方支付">
        <van-cell :value="wxFee / 100" title="微信支付" />
      </van-cell-group>

      <!-- 第一次点时弹出输密码框 -->
      <div class="mt22">
        <van-button block round type="danger" @click="input_pay_pwd" class="budo-15">立即支付</van-button>
      </div>

      <!-- 输密码后再次调用 pay_now -->
      <van-popup v-model="showInputPassword" round :style="{ height: '400px', background: '#f5f5f5' }"
        position="bottom">
        <van-password-input :gutter="10" :value="payPassword" info="输入卡券支付密码(密码为 6 位数字)" style="margin-top: 10px"
          @focus="isVisibKeyboard = true" />
        <van-number-keyboard v-model="payPassword" :maxlength="6" :show="isVisibKeyboard" @input="passwordInput" />
      </van-popup>

      <!-- 免绑卡用户尚无密码 使用短信验证码支付 -->
      <van-popup v-model="showInputMobileCode" round :style="{ height: '400px', background: '#f5f5f5' }"
        position="bottom">
        <div class="budo-mall-popup-title">短信验证码支付</div>

        <van-cell-group inset>
          <van-field label="手机号码" placeholder="请输入手机号码" v-model="orderPayMobile">
            <van-button slot="button" round size="mini" @click="orderPaySendSms">发送验证码</van-button>
          </van-field>
          <van-field label="短信验证码" placeholder="请输入验证码" v-model="payPassword"></van-field>
        </van-cell-group>

        <div class="margin-15">
          <van-button block round @click="orderPayBySms">确认支付</van-button>
        </div>
      </van-popup>
    </template>
  </div>
</template>

<script>
import { api_get_order_type, mall_orders_repay } from "@/api/goods-api";
import { wx_sdk_wx_pay } from "@/util/wxSdk";
import { Dialog, Toast } from "vant";
import { mall_wx_get_user_info } from "@/api/login";
import request from "@/util/axios";
import qs from "qs";

export default {
  name: "order-pay",

  data() {
    return {
      orderId: "",
      wxFee: 0,
      cardMoney: 0,
      cardQuantity: 0,
      orderType: 0,
      payPassword: "",
      isVisibKeyboard: false,
      showInputPassword: false,
      orderInfo: {},
      wxUserInfo: null,

      showInputMobileCode: false,
      orderPayMobile: "",
    };
  },

  created() {
    this.orderId = this.$route.query.orderId;
    this.wxFee = +this.$route.query.wxTotal;
    this.cardQuantity = +this.$route.query.cardQuantity;
    this.cardMoney = +this.$route.query.cardMoney;

    api_get_order_type(this.orderId).then((res) => {
      if (res.code < 1) {
        this.orderType = res.data;
        return;
      }

      Dialog.alert({ message: res.msg });
    });

    this.orderInfo = this.$store.getters.orderInfo;
  },

  mounted() {
    mall_wx_get_user_info().then((res) => {
      this.wxUserInfo = res.data;
    });
  },

  methods: {
    orderPaySendSms() {
      if (!/^1[3456789]\d{9}$/.test(this.orderPayMobile)) {
        $budo_toast("请输入正确的手机号");
        return;
      }

      $budo_toast("发送短信验证码 ..");

      request.post("/mall/order-pay-send-sms", qs.stringify({
        mobile: this.orderPayMobile,
        orderId: this.orderId,
      })).then((res) => {
        budo_log.info("#95 order-pay-send-sms", res);

        $budo_toast("短信验证码已发送");
      });
    },

    orderPayBySms() {
      if (!this.payPassword || this.payPassword.length < 6) {
        $budo_toast("请输入验证码");
        return;
      }

      this.pay_now();
    },

    passwordInput(value) {
      this.payPassword += value;
      if (this.payPassword.length === 6) {
        this.pay_now(); // 再次调用 pay now
      }
    },

    order_list_url() {
      return { path: "order-list" };
    },

    input_pay_pwd() {
      budo_log.info("#82 input_pay_pwd", this.wxUserInfo);

      // 不用输密码
      if (this.wxUserInfo && this.wxUserInfo.quickEx) {
        Dialog.confirm({ message: "确认支付?" }).then(() => {
          this.pay_now();
        });
        return;
      }

      // 输短信验证码
      if (
        this.wxUserInfo &&
        this.wxUserInfo.openid.indexOf("user-for-card-$$$") > -1
      ) {
        this.showInputMobileCode = true;
        return;
      }

      // 输密码
      this.showInputPassword = true;
    },

    pay_now() {
      Toast("正在支付 ..");

      let orderListUrl = this.order_list_url();

      budo_log.debug("#119 mall_orders_repay, pay_now, orderListUrl=", orderListUrl, "orderType=", this.orderType);

      mall_orders_repay(this.orderId, this.payPassword).then((res) => {
        if (res.code !== 0) {
          this.payPassword = "";
          Dialog({ message: "支付失败:" + res.msg });
        } else {
          if (res?.data?.payData?.paySign) { // 有微信补差
            const param = { data: res.data.payData };
            param.data.sign = res.data.payData.paySign;

            wx_sdk_wx_pay(param, () => {
              Dialog.confirm({ message: "微信支付成功, 去订单" }).then(() => {
                this.$router.push(orderListUrl);
              });
            }, () => {
              this.$router.push(orderListUrl);
            }
            );
          } else {
            Dialog.confirm({ message: "支付成功, 去订单" }).then(() => {
              this.$router.push(orderListUrl);
            });
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.page-bg {
  height: 100vh;
  background-color: #edf0f5;
  padding: 8px;
}
</style>
